
const initVideoHtml5 = () => {
    const windowWidth = $(window).width();
    const device = windowWidth >= 1024 ? 'desktop' : (windowWidth >=768 ? 'tablet' : 'mobile');    

    $('.video-js-html5').each(function(index, element) {
        var urlVideo = $(element).attr('data-src-desktop');
        switch (device) {
          case 'desktop':
            urlVideo = $(element).attr('data-src-desktop')
            break;
          case 'tablet':
            urlVideo = $(element).attr('data-src-tablet')
            break;
          case 'mobile':
            urlVideo = $(element).attr('data-src-mobile')
            break;
          default:
            urlVideo = $(element).attr('data-src-desktop')
        }
        $(element).attr('data-src', urlVideo);
    });
}

module.exports = {
    initVideoHtml5,
};
